import React from 'react';
import { Observable } from 'rxjs';
import { EnvironmentContextProps, IEnvironment } from './types';

const createDefault = (): EnvironmentContextProps => ({
  watchEnvironment: (): Observable<IEnvironment> => {
    console.warn(
      'Ops likely you forgot to add the environment context provider on top of your app',
    );
    return new Observable<IEnvironment>((observer) => {
      observer.complete();
    });
  },
});

export const EnvironmentContext = React.createContext<EnvironmentContextProps>(createDefault());
